var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gradation",on:{"click":function($event){$event.stopPropagation();return _vm.handleSquareBtnClick($event)}}},[_c('span',{staticClass:"text",class:_vm.className},[_vm._v(_vm._s(_vm.text))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }